import { Stack, Typography } from '@mui/material'
import {
  DeepMap,
  FieldError,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { Switch } from 'utoniq-ui'

import { Maybe, TicketItemMetadataInput } from '@/clients/utoniq-core/schema'
import { TextInputCell } from '@/components/pages/ConsoleItemCreate/template/components/Commons'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { CreateItemProps } from '../ItemCreateForm'

type TicketNumberInputCellProps = {
  watch: UseFormWatch<CreateItemProps>
  setValue: UseFormSetValue<CreateItemProps>
  register: UseFormRegister<CreateItemProps>
  errors?: DeepMap<Maybe<TicketItemMetadataInput> | undefined, FieldError>
}

export const TicketNumberInputCell: Cell<TicketNumberInputCellProps> = ({
  watch,
  setValue,
  register,
  errors,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const hasAssignedNumberWatch = watch('hasAssignedNumber')

  return (
    <CellFrame sx={{ pb: 7 }}>
      <Stack direction="row" alignItems="center">
        <Stack flex={1}>
          <Typography variant="h5">
            {t('ticketNumberLabel', '整理番号')}
          </Typography>
        </Stack>
        <Stack>
          <Switch
            checked={hasAssignedNumberWatch}
            onChange={() => {
              if (hasAssignedNumberWatch) {
                setValue(
                  'metadata.ticket.assignedNumberPrefix',
                  null as never,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  }
                )
                setValue('metadata.ticket.startAssignedNumber', null as never, {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              }
              setValue('hasAssignedNumber', !hasAssignedNumberWatch, {
                shouldValidate: true,
                shouldDirty: true,
              })
            }}
          />
        </Stack>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('ticketNumberDesc1')}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {t('ticketNumberDesc2')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('ticketNumberDesc3')}
      </Typography>
      {hasAssignedNumberWatch && (
        <Stack direction="row" sx={{ pt: 2, flexWrap: 'wrap', gap: 2 }}>
          <Stack flex={1}>
            <TextInputCell
              type="text"
              {...register('metadata.ticket.assignedNumberPrefix')}
              error={errors?.assignedNumberPrefix}
            />
          </Stack>
          <Stack flex={1}>
            <TextInputCell
              type="number"
              {...register('metadata.ticket.startAssignedNumber')}
              error={errors?.startAssignedNumber}
            />
          </Stack>
        </Stack>
      )}
    </CellFrame>
  )
}
